export const routes = (parentName) => {
  return [
    {
      path: "podcast",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Podcast-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Podcast-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Podcast-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Podcast-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
